import React, { createContext, useState, useContext, useEffect } from 'react';
const AuthContext = createContext(null);
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  useEffect(() => {
    const token = localStorage.getItem('token');
    const userId = localStorage.getItem('userId');
    if (token && userId) {
      setUser({
        token,
        userId,
        username: localStorage.getItem('username') || '',
        role: localStorage.getItem('role') || '',
        nombre: localStorage.getItem('nombre') || '',
        apellido: localStorage.getItem('apellido') || ''
      });
    }
  }, []);
  const login = (token, userId, username, role, nombre, apellido) => {
    localStorage.setItem('token', token);
    localStorage.setItem('userId', userId);
    localStorage.setItem('username', username || '');
    localStorage.setItem('role', role || '');
    localStorage.setItem('nombre', nombre || '');
    localStorage.setItem('apellido', apellido || '');
    setUser({ token, userId, username, role, nombre, apellido });
  };
  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.removeItem('username');
    localStorage.removeItem('role');
    localStorage.removeItem('nombre');
    localStorage.removeItem('apellido');
    setUser(null);
  };
  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
export const useAuth = () => useContext(AuthContext);
